import React from "react";

import { logoSrc } from "./Brand";

export default function TirSideView({ L, H, placements, colorOf, labelOf, title, selected, brand }) {
  const X0 = 250, TW = 930, sc = TW / L, TH = Math.max(120, H * sc), TOP = 46, BASE = TOP + TH;
  const items = placements.map((p, i) => ({ ...p, i })).sort((a, b) => b.y - a.y);
  return (
    <svg data-testid="tir-side-view" viewBox={`0 0 1200 ${BASE + 70}`} className="w-full rounded-lg bg-white">
      <text x={X0} y={30} fontSize="24" fontWeight="800" fill="#0f172a" fontFamily="Oswald, sans-serif">{title}</text>
      <path d={`M40 ${BASE + 18} L40 ${BASE - 70} Q42 ${BASE - 150} 120 ${BASE - 170} L205 ${BASE - 175} Q235 ${BASE - 175} 238 ${BASE - 140} L240 ${BASE + 18} Z`} fill="#f8fafc" stroke="#94a3b8" strokeWidth="2" />
      <path d={`M70 ${BASE - 120} L150 ${BASE - 140} L150 ${BASE - 90} L70 ${BASE - 85} Z`} fill="#334155" />
      <rect x="160" y={BASE - 138} width="58" height="48" rx="3" fill="#475569" />
      {brand?.name && (
        <g data-testid="side-brand">
          {brand.logo_url
            ? <image href={logoSrc(brand.logo_url)} x="78" y={BASE - 78} width="120" height="50" preserveAspectRatio="xMidYMid meet" />
            : <text x="138" y={BASE - 46} textAnchor="middle" fontSize="15" fontWeight="800" fill="#475569" fontFamily="Oswald, sans-serif">{String(brand.name).slice(0, 14)}</text>}
        </g>
      )}
      <rect x="40" y={BASE - 20} width="200" height="16" fill="#cbd5e1" />
      <rect x={X0 - 10} y={BASE + 2} width={TW + 20} height="16" fill="#94a3b8" />
      {[110, X0 + 40, X0 + 110, X0 + TW - 230, X0 + TW - 160, X0 + TW - 90].map((cx) => (
        <g key={cx}><circle cx={cx} cy={BASE + 34} r="26" fill="#1e293b" /><circle cx={cx} cy={BASE + 34} r="11" fill="#cbd5e1" /></g>
      ))}
      <rect x={X0} y={TOP} width={TW} height={TH} fill="#e5e7eb" stroke="#9ca3af" strokeDasharray="5 4" />
      {items.map((p) => {
        const x = X0 + p.x * sc, w = Math.max(1, p.l * sc), y = BASE - (p.z + p.h) * sc, h = Math.max(1, p.h * sc);
        return (
          <g key={p.i}>
            <rect x={x} y={y} width={w} height={h} fill={p.i === selected ? "#facc15" : colorOf(p.pid)} fillOpacity="0.9" stroke="#fff" strokeDasharray="3 2" strokeWidth="1" rx={p.sekil === "RULO" ? Math.min(w, h) / 2 : 0} />
            {w > 14 && h > 12 && (() => { const t = String(labelOf(p.pid)); const fs = Math.max(8, Math.min(14, h * 0.45, (w - 4) / (t.length * 0.62))); return <text x={x + w / 2} y={y + h / 2 + fs * 0.35} textAnchor="middle" fontSize={fs} fontWeight="800" fill="#fff">{t}</text>; })()}
            <title>{labelOf(p.pid)}</title>
          </g>
        );
      })}
    </svg>
  );
}
